<!--  -->
<template>
	<div class="carBg">
		<centter-1 :target="leftTarget" />
		<!-- 上侧 -->
		<div class="point1">
			<div class="inner flex flex-direction">
				<div class="location">
					<i class="el-icon-location-outline margin-right-5"></i>{{ stationName }} 
				</div>
				<div class="line"></div>
				<div class="ecInfo flex justify-around">
					<div class="circleMove" id="circleMove">
						<div class=" circleInner flex flex-direction justify-center">
							<div class="DS-font text-30 green-text text-center">{{ ChargeNum }}</div>
							<!-- 日换电次数 -->
							<div style="white-space: nowrap;">当天换电次数</div>
						</div>
					</div>
					<div class="flex flex-direction align-center">
						<div>空闲中电池</div>
						<div class="text-xxl-xl DS-font green-text">
							{{ battery.freeBatteryNum || 0 }}
						</div>
					</div>
					<div class="flex flex-direction align-center">
						<div>充电中电池</div>
						<div class="text-xxl-xl DS-font green-text">
							{{ battery.chargingBatteryNum || 0 }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 底部 -->
		<div class="point2">
			<div class="inner"></div>
			<div class="flex justify-around">
				<div class="ecQuantity flex flex-direction align-center">
					<div class="ecQuantityText">当天换电时长(h)</div>
					<div class="ecQuantityCounts DS-font text-xl" style="margin-top: 15px">
						{{ changeDatteryTime || 0 }}
					</div>
					<!-- <div class="ecQuantityPie">
						<CirclePie :cdata="cdata1" :height="'70'" :width="'70'" />
					</div> -->
				</div>
				<div class="ecQuantity flex flex-direction align-center">
					<div class="ecQuantityText">当天电量(kWh)</div>
					<div class="ecQuantityCounts DS-font text-xl" style="margin-top: 15px">
						{{ sameElectricQuantity || 0 }}
					</div>
					<!-- <div class="ecQuantityPie">
						<CirclePie :cdata="cdata2" :height="'70'" :width="'70'" />
					</div> -->
				</div>
			</div>
		</div>
		<!-- 中间 -->
		<div v-if="batteryId" class="point3 flex justify-center align-center" @click="jumpToBatteryHolder">
			进入充电仓<img class="img" src="@/assets/images/site/arrow_small.png" />
		</div>
		<centter-2 :target="rightTarget" />
	</div>
</template>

<script>
// import CirclePie from "@/components/echart/circlePie"
import { dataInterface } from "@/api/dataInterfaceApi"
import centter1 from './center-1'
import centter2 from './center-2'

export default {
	components: {
		// CirclePie,
		centter1,
		centter2
	},
	props: {
	},
	data() {
		let { stationId } = this.$route.query
		return {
			stationId: stationId,
			batteryId: '',
			chargingWarehouseNumber: '',
			changeDatteryTime: "",
			sameElectricQuantity: "",
			ChargeNum: "",
			battery: {
				freeBatteryNum: "",
				chargingBatteryNum: ""
			},
			stationName: this.sName,
			leftTarget: [
                {
                    icon: require('@/assets/images/exposition/chd-6.png'),
                    number: '',
                    label: '排队数量',
                    color: '#36FBFB',
					// fontSize: 40,
                },
                {
                    icon: require('@/assets/images/exposition/chd-5.png'),
                    number: '',
                    label: '电池数量(块)',
                    color: '#43FFB9',
					// fontSize: 40,
                },
                {
                    icon: require('@/assets/images/exposition/chd-3.png'),
                    number: '',
                    label: '换电价格(元)',
                    color: '#FFFFFF',
					// fontSize: 40,
                },
                {
                    icon: require('@/assets/images/exposition/chd-4.png'),
                    number: '',
                    label: '换电次数(次)',
                    color: '#179DFF',
					overTenThousand: true,
					// fontSize: 40,
                },
                {
                    icon: require('@/assets/images/exposition/chd-7.png'),
                    number: '',
                    label: '累计收入(元)',
                    color: '#36FBFB',
					overTenThousand: true,
					// fontSize: 40,
                },
            ],
			rightTarget: [
                {
                    icon: require('@/assets/images/exposition/chd-8.png'),
                    number: '',
                    label: '站点',
					color: '#36FBFB'
                },
                {
                    icon: require('@/assets/images/exposition/chd-4.png'),
                    number: '',
                    label: '类型',
					color: '#43FFB9'
                },
                {
                    icon: require('@/assets/images/exposition/chd-11.png'),
                    number: '',
                    label: '建站时间',
					color: '#FFFFFF'
                },
                {
                    icon: require('@/assets/images/exposition/chd-10.png'),
                    number: '',
                    label: '运营天数',
					color: '#179DFF'
                },
                {
                    icon: require('@/assets/images/exposition/chd-9.png'),
                    number: '',
                    label: '支持车型',
					color: '#36FBFB'
                },
            ],
		};
	},
    computed: {},
    watch: {},
	mounted() {},
	methods: {
		getData(data) {
			// 站点信息
			this.zhandianxinxi(data)
			// 站点-当天换电次数
			this.dayhuandiancishu(data)
			// 站点-中间-当天换电时长
			this.todayhdsc(data)
			// 站点-中间-空闲中充电中电池数量
			this.kongxianchongdiandianchi(data)
			// 获取电池仓信息
			this.getBatteryId(data)
			// // 站点-中间-当天换电量
			// this.todaydl(data)
		},

		// 站点信息
		zhandianxinxi(data) {
			let _this = this
			let params = {
				'enCode': "TiDB-zhandian-zhandianxinxi",
				"@station_id": _this.stationId,
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				let data = res[0] || {}
				this.stationName = data.stationName

				this.leftTarget[0].number = data.lineUpNum
				this.leftTarget[1].number = data.houseTotalBatteries
				this.leftTarget[2].number = data.changePowerPrice
				this.leftTarget[3].number = data.PowerNum
				this.leftTarget[4].number = data.oper_income
				console.log(this.leftTarget, 'left')

				this.rightTarget[0].number = data.stationName
				this.rightTarget[1].number = data.stationType
				this.rightTarget[2].number = data.constructionTime
				this.rightTarget[3].number = data.safeDays
				this.rightTarget[4].number = data.vehicleBrand

			})
			.catch((err) => {
				console.log(err);
			})
		},

		// 站点-当天换电次数
		dayhuandiancishu(data) {
			let _this = this
			let params = {
				'enCode': "TiDB-chongdianjidangtianhuandianshichang",
				"@station_id": _this.stationId,
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				let data = res[0] || {}
				_this.ChargeNum = data.ChargeNum
				_this.changeDatteryTime = data.ChargeTime
			})
			.catch((err) => {
				console.log(err);
			})
		},

		// 站点-中间-当天换电时长
		todayhdsc(data) {
			const day = new Date().getDate().toString().padStart(2, 0);
			let _this = this
			let params = {
				enCode: "TD-dangtianhuandiandianliang-new-sid",
				"@station_id": _this.stationId,
				'@cur_date': new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate().toString().padStart(2, 0) + " 00:00:00"
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				let data = res[0] || {}
				_this.sameElectricQuantity = data.PowerCharge
			})
			.catch((err) => {
				console.log(err)
			})
		},

		// 站点-中间-空闲中充电中电池数量
		kongxianchongdiandianchi(data) {
			let _this = this
			let params = {
				enCode: "TiDB-zhandian-kongxianchongdiandianchi",
				"@station_id": _this.stationId,
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				let data = res[0] || {}
				_this.battery.freeBatteryNum = data.freeBatteryNum
				_this.battery.chargingBatteryNum = data.chargingBatteryNum
			})
			.catch((err) => {
				console.log(err)
			})
		},

		// 获取电池仓信息
		getBatteryId(data = {}){
			let _this = this
			let params = {
				'enCode':'chongdiancang-TiDB',
				'@station_id': _this.stationId,
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if(!res || !res.length) return
				let data = res[0] || {}
				this.batteryId = data.batteryId || ''
				this.chargingWarehouseNumber = data.chargingWarehouseNumber || ''
				this.$emit('backData', { batteryId: this.batteryId, chargingWarehouseNumber: this.chargingWarehouseNumber })
			})
		},

		// // 站点-中间-当天换电量
		// todaydl(data) {
		// 	let _this = this
		// 	let params = {
		// 		enCode: "TiDB-Energy-zhandian-todaydl",
		// 		"@station_id": _this.stationId,
		// 	}
		// 	dataInterface.dataFaceApi(params).then((res) => {
		// 		if (!res || !res.length) return
		// 		let data = res[0] || {}
		// 		_this.changeDatteryTime = data.ChargeTime
		// 		_this.sameElectricQuantity = data.ChargeNum
		// 	})
		// 	.catch((err) => {
		// 		console.log(err)
		// 	});
		// },
		// 跳转到电池仓页面
		jumpToBatteryHolder() {
			let { stationId, batteryId, chargingWarehouseNumber } = this
			this.$router.push({
				path: "/batteryCompartment",
				query: {
					stationId: stationId,
					batteryId: batteryId,
					chargingWarehouseNumber: chargingWarehouseNumber,
				},
			})
		},
	},
}

</script>
<style lang="scss" scoped>
$green-text: #49fff9;

.green-text {
	color: $green-text;
}

.carBg {
	width: 100%;
	height: 100%;
	position: relative;
	background: url("~@/assets/images/site/car.png") center no-repeat;
	background-size: 70%;
	font-size: 14px;
}

.circleMove {
	position: relative;
	width: 105px;
	height: 105px;
	// border:6px solid $green-text;
	border-radius: 50%;

	.circleInner {
		width: 90px;
		height: 90px;
		position: absolute;
		background: url("~@/assets/images/site/circle_icon.png");
		background-size: 100% 100%;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
}

.ecInfo {
	width: 100%;
	height: 100%;
	padding: 30px 20px 0;
	align-items: center;
}

.location {
	margin: 16px auto 12px ;
	justify-content: start;
	display: flex;
	width: 331px;
	align-items: center;
	> i {
		height: 12px;
	}
}

.line {
	width: 331px;
	height: 1px;
	/*no*/
	background: #3dbcc1;
	margin: 0 auto;
}

.point1,
.point2,
.point3 {
	position: absolute;
}

.point1 {
	width: 496px;
	height: 284px;
	background: url("~@/assets/images/site/point1.png");
	background-size: 100% 100%;
	top: 50%;
    left: 50%;
    transform: translate(-10%, -160%);

	.inner {
		position: absolute;
		width: 396px;
		height: 188px;
		left: 100px;
	}
}

.point2 {
	min-width: 340px;
	min-height: 146px;
	background-image: linear-gradient(180deg,
			rgba(14, 134, 139, 0.88) 3%,
			rgba(0, 43, 41, 0.6) 100%);
	border: 1px solid #1a7683;
	bottom: 28%;
    left: 12%;
	padding: 12px 15px;

	.inner {
		width: 94px;
		height: 132px;
		background: url("~@/assets/images/site/point.png");
		background-size: cover;
		position: absolute;
		top: -66px;
		right: -94px;
	}

	.ecQuantityText {
		background: rgb(106, 173, 172, 0.6);
		padding: 4px 9px;
	}

	.ecQuantityPie {
		width: 90px;
		height: 70px;
	}
}

.point3 {
	// width:138px;
	// height:40px;
	background: #00bab8;
	border-radius: 2px;
	font-size: 18px;
	font-weight: 500;
	padding: 8px 13px;
	top: 46%;
    left: 41%;
	cursor: pointer;

	.img {
		width: 16px;
		height: 16px;
		margin-right: 5px;
		// transform: rotate(180deg);
	}
}

.DS-font {
	font-family: "DS-Digital-Bold";
}
</style>